/* Boston Tech · Propuesta A (solo diseño). No cambia textos: solo agrupa y muestra. */
(function () {
  'use strict';

  /* Formato de precio con el formato de la tienda */
  function formatoDinero(cents) {
    var formato = (window.theme && window.theme.moneyFormat) || '{{amount_with_comma_separator}} €';
    var valor = (cents / 100).toFixed(2);
    var partes = valor.split('.');
    var miles = function (s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    var reemplazos = {
      amount: miles(partes[0], ',') + '.' + partes[1],
      amount_no_decimals: miles(String(Math.round(cents / 100)), ','),
      amount_with_comma_separator: miles(partes[0], '.') + ',' + partes[1],
      amount_no_decimals_with_comma_separator: miles(String(Math.round(cents / 100)), '.')
    };
    return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, clave) {
      return reemplazos[clave] !== undefined ? reemplazos[clave] : reemplazos.amount_with_comma_separator;
    });
  }

  /* 1. Descripción del producto en desplegables (solo si tiene 2 o más secciones H2) */
  function desplegables() {
    var bloques = document.querySelectorAll('.product-block-list__item--description .rte');
    Array.prototype.forEach.call(bloques, function (rte) {
      if (rte.getAttribute('data-bt-acc')) return;
      var titulos = Array.prototype.filter.call(rte.children, function (n) { return n.tagName === 'H2'; });
      if (titulos.length < 2) return;
      rte.setAttribute('data-bt-acc', '1');
      titulos.forEach(function (h2) {
        var detalle = document.createElement('details');
        detalle.className = 'bt-acc';
        var resumen = document.createElement('summary');
        var cuerpo = document.createElement('div');
        cuerpo.className = 'bt-acc__cuerpo';
        var nodo = h2.nextSibling;
        while (nodo && !(nodo.nodeType === 1 && nodo.tagName === 'H2')) {
          var siguiente = nodo.nextSibling;
          cuerpo.appendChild(nodo);
          nodo = siguiente;
        }
        rte.insertBefore(detalle, h2);
        resumen.appendChild(h2);
        detalle.appendChild(resumen);
        detalle.appendChild(cuerpo);
      });
    });
  }

  /* 2. Precio con la Oferta Flash y barra fija: se actualizan al cambiar de variante */
  function datosProducto(formulario) {
    var tarjeta = formulario.closest('.card') || document;
    var script = tarjeta.querySelector('[data-product-json]');
    if (!script) return null;
    try { return JSON.parse(script.textContent).product; } catch (e) { return null; }
  }

  function actualizarPrecios(formulario) {
    var producto = datosProducto(formulario);
    var campo = formulario.querySelector('[name="id"]');
    if (!producto || !campo) return;
    var variante = null;
    for (var i = 0; i < producto.variants.length; i++) {
      if (String(producto.variants[i].id) === String(campo.value)) { variante = producto.variants[i]; break; }
    }
    if (!variante) return;
    var conFlash = Math.round(variante.price * 0.9);
    document.querySelectorAll('[data-bt-flash-precio]').forEach(function (n) { n.textContent = formatoDinero(conFlash); });
    document.querySelectorAll('[data-bt-precio]').forEach(function (n) { n.textContent = formatoDinero(variante.price); });
    var barra = document.querySelector('[data-bt-barra]');
    if (barra) barra.setAttribute('data-disponible', variante.available ? '1' : '0');
  }

  function preciosFlash() {
    document.querySelectorAll('form.product-form').forEach(function (formulario) {
      if (!formulario.querySelector('[data-bt-flash]')) return;
      formulario.addEventListener('change', function () { setTimeout(function () { actualizarPrecios(formulario); }, 60); });
    });
  }

  function barraFija() {
    var barra = document.querySelector('[data-bt-barra]');
    var boton = document.querySelector('.product-form__add-button');
    if (!barra || !boton || !('IntersectionObserver' in window)) return;
    document.body.appendChild(barra);
    var visto = false;
    var observador = new IntersectionObserver(function (entradas) {
      var e = entradas[0];
      var pasado = !e.isIntersecting && e.boundingClientRect.top < 0;
      if (e.isIntersecting) visto = true;
      var mostrar = visto && pasado && barra.getAttribute('data-disponible') !== '0';
      barra.classList.toggle('is-visible', mostrar);
      document.body.classList.toggle('bt-barra-activa', mostrar);
    });
    observador.observe(boton);
    barra.querySelector('[data-bt-barra-boton]').addEventListener('click', function () {
      var principal = document.querySelector('.product-form__add-button');
      if (principal && !principal.disabled) principal.click();
    });
  }

  function iniciar() {
    desplegables();
    preciosFlash();
    barraFija();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();